"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[846],{

/***/ 761203:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ LoginUserIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);

var LoginUserIcon = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: props.width || "16",
        height: props.height || "18.963",
        viewBox: "0 0 24.02 24.49",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
            id: "user-10",
            transform: "translate(-23.819 -26.9)",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Path_132898",
                    "data-name": "Path 132898",
                    d: "M54.666,33.833a6.833,6.833,0,1,0-6.833,6.833A6.834,6.834,0,0,0,54.666,33.833Zm-11.883,0a5.05,5.05,0,1,1,5.05,5.05A5.046,5.046,0,0,1,42.782,33.833Z",
                    transform: "translate(-12.005)",
                    stroke: "#000",
                    strokeWidth: "0.2",
                    fill: props.color
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    id: "Path_132899",
                    "data-name": "Path 132899",
                    d: "M24.39,89.081a.838.838,0,0,0,.446.119.861.861,0,0,0,.772-.446,11.756,11.756,0,0,1,20.469,0,.892.892,0,0,0,1.545-.891,13.566,13.566,0,0,0-23.588,0A.893.893,0,0,0,24.39,89.081Z",
                    transform: "translate(0 -37.958)",
                    stroke: "#000",
                    strokeWidth: "0.2",
                    fill: props.color
                })
            ]
        })
    });
};


/***/ }),

/***/ 128036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Headers_CollectionHeaderDropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(225617);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(913886);
// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(540190);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(811163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/CollectionHeaderDropdown/useCollectionClick.js



function useCollectionClick(toggleDropdown) {
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var handleCollectionClick = function(collection) {
        var ref;
        router_default().push((0,routes.getRoute)("".concat(routes.PATH.collectionCategories(collection.id)), storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        /*
      if toggleDropdown !== undefined, then close header dropdown
      only for mobile usage
    */ toggleDropdown === null || toggleDropdown === void 0 ? void 0 : toggleDropdown();
    };
    return [
        handleCollectionClick
    ];
}

// EXTERNAL MODULE: ./src/redux/ssrStore.ts + 1 modules
var ssrStore = __webpack_require__(326706);
// EXTERNAL MODULE: ./src/components/DesignSystem/NextImage/index.ts + 1 modules
var NextImage = __webpack_require__(527941);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/CollectionHeaderDropdown/CollectionHeaderDropdownWidget1.tsx






var CollectionHeaderDropdownWidget1 = function(param) {
    var _classes = param.classes, classes = _classes === void 0 ? "" : _classes, _toggleDropdown = param.toggleDropdown, toggleDropdown = _toggleDropdown === void 0 ? undefined : _toggleDropdown;
    var ref = (0,_sliced_to_array/* default */.Z)(useCollectionClick(toggleDropdown), 1), handleCollectionClick = ref[0];
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections
        };
    }).collections;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "collection-list-container__body ".concat(classes),
        children: collections === null || collections === void 0 ? void 0 : collections.filter(function(collection) {
            return collection.id !== 0;
        }).map(function(collection, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "collection-item",
                onClick: function() {
                    return handleCollectionClick(collection);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "collection-image",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                            alt: "collection ".concat(index + 1),
                            layout: "fill",
                            loading: "lazy",
                            decoding: "async",
                            quality: 70,
                            src: collection.image_url || constants/* DEFAULT_COLLECTION_IMAGE */.t6[index],
                            unoptimized: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "collection-name ttu",
                        children: collection.name
                    })
                ]
            }, collection.id);
        })
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/CollectionHeaderDropdown/CollectionHeaderDropdownWidget3.js





var CollectionHeaderDropdownWidget3 = function(param) {
    var toggleDropdown = param.toggleDropdown;
    var ref = (0,_sliced_to_array/* default */.Z)(useCollectionClick(toggleDropdown), 1), handleCollectionClick = ref[0];
    var ref1 = (0,react.useState)(null), accordionId = ref1[0], setAccordionId = ref1[1];
    var collections = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            collections: state.catalogReducer.collections
        };
    }).collections;
    var accordionHeaderClick = function(e) {
        e.stopPropagation();
        var dataId = e.target.getAttribute("data-id");
        if (+dataId === accordionId) {
            setAccordionId(null);
            return;
        } else if (+dataId) {
            setAccordionId(+dataId);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "collection-list-container__body collection-header-widget-3",
        children: (collections === null || collections === void 0 ? void 0 : collections.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "collection-accordion",
            children: collections === null || collections === void 0 ? void 0 : collections.map(function(collection) {
                var ref;
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                    className: "collection-accordion__container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex items-center justify-between collection-accordion__header pointer",
                            "data-id": collection.id,
                            onClick: accordionHeaderClick,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mv0 z-1",
                                    onClick: accordionHeaderClick,
                                    children: collection.name
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    "data-id": collection.id,
                                    style: {
                                        transform: "rotate(".concat(accordionId === collection.id ? "180deg" : "0deg", ")")
                                    },
                                    alt: "dropdown button",
                                    src: "/assets/images/down-arrow-thin.svg",
                                    className: "z-0"
                                })
                            ]
                        }),
                        accordionId === collection.id && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "collection-accordion__body",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "body-list",
                                children: collection === null || collection === void 0 ? void 0 : (ref = collection.categories) === null || ref === void 0 ? void 0 : ref.map(function(category) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "pointer body-list--item",
                                        onClick: function() {
                                            return handleCollectionClick(collection);
                                        },
                                        children: category.name
                                    }, category.id);
                                })
                            })
                        })
                    ]
                }, collection.id);
            })
        }) : null
    });
};

// EXTERNAL MODULE: ./src/assets/svgExports/UserIconDark.js
var UserIconDark = __webpack_require__(252514);
// EXTERNAL MODULE: ./src/utils/excuteLogout.js
var excuteLogout = __webpack_require__(385126);
// EXTERNAL MODULE: ./src/components/LogoutModal/index.js
var LogoutModal = __webpack_require__(821448);
// EXTERNAL MODULE: ./src/hooks/useFeatureLocks.ts
var useFeatureLocks = __webpack_require__(482516);
// EXTERNAL MODULE: ./src/components/InstallAppInstructionsOverlay/useInstallAppOverlayActions.tsx
var useInstallAppOverlayActions = __webpack_require__(141771);
// EXTERNAL MODULE: ./src/utils/checkIfWebview.js
var checkIfWebview = __webpack_require__(493326);
// EXTERNAL MODULE: ./src/utils/getNavList.js
var getNavList = __webpack_require__(704956);
;// CONCATENATED MODULE: ./src/components/DesignSystem/Headers/CollectionHeaderDropdown/index.js
















var InstallAppInstructionsOverlay = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 557).then(__webpack_require__.bind(__webpack_require__, 700557));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(700557)
            ];
        }
    },
    ssr: false
});
var CollectionHeaderDropdown = function(param) {
    var navItemsState = param.navItemsState, renderNavType = param.renderNavType, openCollections = param.openCollections, goBack = param.goBack, collectionListType = param.collectionListType, toggleDropdown = param.toggleDropdown, isLoginVisible = param.isLoginVisible, headerName = param.headerName;
    var toggleLogoutModal = function toggleLogoutModal() {
        setShowLogoutConfirmation(!showLogoutConfirmation);
    };
    var ref = (0,react.useState)(false), showLogoutConfirmation = ref[0], setShowLogoutConfirmation = ref[1];
    var userLogin = (0,es/* useSelector */.v9)(function(state) {
        return {
            userLogin: state.userReducer.isLogin
        };
    }).userLogin;
    var ref1 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            storeCollections: state.catalogReducer.collections
        };
    }), storeData = ref1.storeData, storeCollections = ref1.storeCollections;
    var ref2 = (0,useFeatureLocks/* useFeatureLocks */.r)(), installAppFeatureStatus = ref2.installAppFeatureStatus, wishlistFeatureStatus = ref2.wishlistFeatureStatus;
    var openIntallAppOverlay = (0,useInstallAppOverlayActions/* default */.Z)().openIntallAppOverlay;
    var isWebview = (0,checkIfWebview/* default */.Z)();
    (0,react.useEffect)(function() {
        if (showLogoutConfirmation) setShowLogoutConfirmation(false);
    }, [
        userLogin
    ]);
    var toggleAuthModal = function() {
        if (userLogin) {
            toggleLogoutModal();
        } else {
            var ref;
            router_default().push((0,routes.getRoute)(routes.PATH.ORDERS, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
        }
    };
    var renderMobileLoginLogout = function() {
        var ref, ref1;
        if (headerName === "header14" && !isLoginVisible) {
            return null;
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "flex items-center justify-between mt3",
            onClick: toggleAuthModal,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mr3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserIconDark/* UserIconDark */.q, {
                            color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== "#ffffff" ? "#000000" : "#ffffff",
                            width: "18",
                            height: "18"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: userLogin ? "red" : "black",
                        children: userLogin ? "Logout" : "Login"
                    })
                ]
            })
        });
    };
    var renderCollectionList = function() {
        switch(collectionListType){
            case "CollectionHeaderDropdownWidget1":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeaderDropdownWidget1, {
                    classes: "collection-header-widget-1",
                    toggleDropdown: toggleDropdown
                });
            case "CollectionHeaderDropdownWidget2":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeaderDropdownWidget1, {
                    classes: "collection-header-widget-2",
                    toggleDropdown: toggleDropdown
                });
            case "CollectionHeaderDropdownWidget3":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeaderDropdownWidget3, {
                    toggleDropdown: toggleDropdown
                });
            default:
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionHeaderDropdownWidget1, {
                    classes: "collection-header-widget-1",
                    toggleDropdown: toggleDropdown
                });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "dropdown ".concat(openCollections ? "active" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "nav-state",
                        children: (navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                            className: "dropdown--menu w-100",
                            children: [
                                navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.map(function(page) {
                                    return renderNavType(page, true);
                                }),
                                !(wishlistFeatureStatus === null || wishlistFeatureStatus === void 0 ? void 0 : wishlistFeatureStatus.isLocked) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "menu-item",
                                    onClick: function() {
                                        var ref;
                                        router_default().push((0,routes.getRoute)(routes.PATH.WISHLIST, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Wishlist"
                                    })
                                }),
                                !isWebview && (installAppFeatureStatus === null || installAppFeatureStatus === void 0 ? void 0 : installAppFeatureStatus.isVisible) && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "menu-item black pwa:tw-hidden",
                                    onClick: function() {
                                        openIntallAppOverlay();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: "Install App"
                                    })
                                }),
                                !(0,getNavList/* showMyAccount */.p6)() && /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                    className: "menu-item",
                                    style: {
                                        borderTop: "1px solid #ebebeb"
                                    },
                                    children: renderMobileLoginLogout()
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "collection-list-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "collection-list-container__header",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    onClick: goBack,
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "/assets/images/down-arrow-thin.svg",
                                            alt: "dropdown button",
                                            className: "mr3",
                                            style: {
                                                width: 13,
                                                transform: "rotate(90deg)"
                                            }
                                        }),
                                        "Shop"
                                    ]
                                })
                            }),
                            (storeCollections === null || storeCollections === void 0 ? void 0 : storeCollections.length) ? renderCollectionList() : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InstallAppInstructionsOverlay, {}),
            showLogoutConfirmation && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoutModal["default"], {
                toggleLogoutModal: toggleLogoutModal,
                executeLogout: excuteLogout/* executeLogout */.q,
                showLogoutConfirmation: showLogoutConfirmation
            })
        ]
    });
};
/* harmony default export */ var Headers_CollectionHeaderDropdown = (CollectionHeaderDropdown);


/***/ }),

/***/ 480846:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(626042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(269396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(785893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(811163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(792516);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(667294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(225617);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(540190);
/* harmony import */ var _components_Common_ReactHamburger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70440);
/* harmony import */ var _components_LoginAndDropdownComponent__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(629492);
/* harmony import */ var _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(186812);
/* harmony import */ var _utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(833104);
/* harmony import */ var _utils_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(956494);
/* harmony import */ var _utils_invertAngleRightIconColor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(636874);
/* harmony import */ var _CommonHeaderIcons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(335022);
/* harmony import */ var _CollectionHeaderDropdown__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(128036);
/* harmony import */ var _assets_svgExports_LoginUserIcon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(761203);
/* harmony import */ var _assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(337247);
/* harmony import */ var _assets_svgExports_HeaderHome__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(452882);
/* harmony import */ var _StoreNameComponent__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(644128);
/* harmony import */ var _CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(932461);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(913886);
/* harmony import */ var _hooks_useSaveHeaderHeight__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(953395);
/* harmony import */ var _utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(506337);
/* harmony import */ var _utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(273494);
/* harmony import */ var _redux_ssrStore__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(326706);
/* harmony import */ var _utils_getActualOrDsStoreLogo__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(168491);
/* harmony import */ var _utils_getNavList__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(704956);
/* harmony import */ var src_assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(407056);





























var Header14 = function(props) {
    var getHeaderStyle = function getHeaderStyle() {
        return isDesktop ? "" : "h-70px";
    };
    var ref, ref1, ref2, ref3, ref4;
    var isDesktop = _utils_deviceWidth__WEBPACK_IMPORTED_MODULE_7__/* .deviceWidth */ .o > _utils_constants__WEBPACK_IMPORTED_MODULE_17__/* .MAX_MOBILE_WIDTH */ .Cf;
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), navItemsState = ref6[0], setNavItemsState = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        openShop: false,
        openMore: false,
        openDropdown: false
    }), open = ref7[0], setOpen = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), openCollections = ref8[0], setOpenCollections = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("#ffffff"), headerBgColor = ref9[0], setHeaderBgColor = ref9[1];
    var user = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useSelector */ .v9)(function(state) {
        return {
            user: state.userReducer
        };
    }).user;
    var ref10 = (0,_redux_ssrStore__WEBPACK_IMPORTED_MODULE_21__/* .useSSRSelector */ .kF)(function(state) {
        return {
            storeData: state.storeReducer.store,
            navigationList: state.additionalPagesReducer.navigationList
        };
    }), storeData = ref10.storeData, navigationList = ref10.navigationList;
    var storeLogo = (0,_utils_getActualOrDsStoreLogo__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(storeData);
    var headerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    (0,_hooks_useSaveHeaderHeight__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(headerRef);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref, ref1;
        if (props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.color_scheme) === null || ref1 === void 0 ? void 0 : ref1.bg_color) {
            var ref2, ref3;
            setHeaderBgColor(props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.color_scheme) === null || ref3 === void 0 ? void 0 : ref3.bg_color);
        }
    }, [
        props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.color_scheme) === null || ref1 === void 0 ? void 0 : ref1.bg_color
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!open.openDropdown) setOpenCollections(false);
    }, [
        open.openDropdown
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var newAllNavList = navigationList.filter(function(nav) {
            return nav.page_type !== "shop";
        });
        setNavItemsState((0,_utils_getNavList__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .ZP)(newAllNavList));
    }, [
        navigationList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if ((storeData === null || storeData === void 0 ? void 0 : storeData.store_id) && !navigationList.length) {
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_25__/* .getNavigationPagesList */ .A7)({
                storeId: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
                isPublished: true
            }));
        }
    }, [
        storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
        navigationList
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    if (_utils_checkRenderEnv__WEBPACK_IMPORTED_MODULE_19__/* .IS_SERVER */ .W6) return null;
    var handleClickOutside = function(e) {
        if (isDesktop) {
            if (ref5.current && ref5.current.contains(e.target)) {
                return;
            }
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, state), {
                    openShop: false,
                    openMore: false
                });
            });
        }
    };
    var handleWishlistClick = function() {
        var ref;
        next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.WISHLIST, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
    };
    var menuItemClick = function(nav) {
        if (nav.page_type === "blank_page" && nav.is_external_url) {
            window.open(nav.slug_url, "_blank");
            open.openDropdown && toggleDropdown();
            return;
        }
        if (nav.slug_url === "shop") {
            if (document.querySelector("#CollectionCategoryProductWidget")) {
                document.querySelector("#CollectionCategoryProductWidget").scrollIntoView();
            } else {
                var ref;
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.PRODUCT, storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
            }
            open.openDropdown && toggleDropdown();
        } else if (nav.slug_url === "subNavList") {
            setOpen(function(state) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, state), {
                    openMore: !open.openMore
                });
            });
        } else {
            if (nav.is_editable) {
                var ref1;
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)(_utils_routes__WEBPACK_IMPORTED_MODULE_4__.PATH.additionalPage(nav.slug_url), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain));
            } else {
                var ref2;
                next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)(nav.slug_url, storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain));
            }
            open.openDropdown && toggleDropdown();
        }
    };
    var navSubList = function(nav) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "cfe-dropdown-nav",
            ref: ref5,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "cfe-dropdown-nav__items",
                children: nav.map(function(navigationItem) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "cfe-dropdown-nav__item",
                        onClick: function() {
                            return menuItemClick(navigationItem);
                        },
                        children: navigationItem.page_name
                    }, navigationItem.page_id);
                })
            })
        });
    };
    var renderNavType = function(page) {
        var dropdownNav = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        switch(page.page_type){
            case "blank_page":
                return page.is_external_url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item relative",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        style: {
                            color: isDesktop ? (0,_utils_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_8__/* .getCustomHeaderTextColor */ .s)(headerBgColor) : ""
                        },
                        className: "".concat(isDesktop ? "" : "black-90", " link"),
                        href: page.slug_url,
                        target: "_blank",
                        rel: "noreferrer",
                        children: page.page_name
                    })
                }, page.page_id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item ".concat((0,_utils_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_8__/* .getCustomHeaderTextColor */ .s)(headerBgColor)),
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: page.page_name
                }, page.page_id);
            case "home":
                var ref, ref1;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: [
                                !isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mr3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderHome__WEBPACK_IMPORTED_MODULE_14__/* .HeaderHome */ .Q, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    bgColor: headerBgColor,
                                    page: page
                                })
                            ]
                        })
                    })
                }, page.page_id);
            case "shop":
                return null;
            case "subNavList":
                var ref2;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center justify-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex items-center",
                                    style: {
                                        flex: "1 1 auto"
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                        page: {
                                            page_name: "More"
                                        },
                                        bgColor: headerBgColor
                                    })
                                }),
                                (page === null || page === void 0 ? void 0 : (ref2 = page.subNavs) === null || ref2 === void 0 ? void 0 : ref2.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    className: (0,_utils_invertAngleRightIconColor__WEBPACK_IMPORTED_MODULE_9__/* .invertAngleRightIconColor */ .p)(headerBgColor),
                                    src: "https://cdn.dotpe.in/longtail/themes/8073865/igP6Hh58.webp",
                                    alt: "dropdown button",
                                    style: {
                                        transform: "rotate(90deg)",
                                        width: 7,
                                        marginLeft: dropdownNav ? "0px" : "8px"
                                    }
                                })
                            ]
                        }),
                        open.openMore && navSubList(page.subNavs)
                    ]
                }, page.page_id);
            case "about-us":
                var ref3, ref4;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item relative",
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex items-center justify-between",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center",
                            style: {
                                flex: "1 1 auto"
                            },
                            children: [
                                !isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "mr3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_HeaderInfoIcon__WEBPACK_IMPORTED_MODULE_13__/* .HeaderInfoIcon */ .V, {
                                        color: (storeData === null || storeData === void 0 ? void 0 : (ref3 = storeData.theme) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.colors) === null || ref4 === void 0 ? void 0 : ref4.primary_color) !== "#ffffff" ? "#000000" : "#ffffff"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommonNavbarText_CommonNavbarText__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                                    bgColor: headerBgColor,
                                    page: page
                                })
                            ]
                        })
                    })
                }, page.page_id);
            default:
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    className: "menu-item ".concat((0,_utils_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_8__/* .getCustomHeaderTextColor */ .s)(headerBgColor)),
                    onClick: function() {
                        return menuItemClick(page);
                    },
                    children: page.page_name
                }, page.page_id);
        }
    };
    var toggleDropdown = function() {
        setOpen(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z)({}, state), {
                openDropdown: !state.openDropdown
            });
        });
    };
    var leftSection = function() {
        var ref;
        return isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
            className: "visible-desktop-flex",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                className: storeLogo && (0,_utils_logoAndNameHelpers__WEBPACK_IMPORTED_MODULE_20__/* .getVisibilityForHeader */ .g)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.store_logo_status) ? "logo_image_desktop" : "dn",
                src: storeLogo,
                alt: "store logo",
                onClick: function() {
                    var ref;
                    return next_router__WEBPACK_IMPORTED_MODULE_1___default().push((0,_utils_routes__WEBPACK_IMPORTED_MODULE_4__.getRoute)("", storeData === null || storeData === void 0 ? void 0 : (ref = storeData.store_info) === null || ref === void 0 ? void 0 : ref.domain));
                }
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "visible-mobile-flex w-100",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Common_ReactHamburger__WEBPACK_IMPORTED_MODULE_5__["default"], {
                open: open.openDropdown,
                setOpen: toggleDropdown,
                theme: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_28__/* .getContrastingColor */ .Q)(headerBgColor)
            })
        });
    };
    var middleSection = function() {
        if (isDesktop) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StoreNameComponent__WEBPACK_IMPORTED_MODULE_15__/* .StoreNameComp */ ._, {
                customClass: "justify-center tc"
            });
        }
        return null;
    };
    var rightSection = function() {
        var ref, ref1;
        if (isDesktop) {
            var ref2, ref3;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "flex items-center justify-end icon-set nr4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: handleWishlistClick,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_assets_svgExports_WishlistHeartIcon__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                            color: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_28__/* .getContrastingColor */ .Q)(headerBgColor)
                        })
                    }),
                    (props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.hidden_components) === null || ref3 === void 0 ? void 0 : ref3.login_view) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_LoginAndDropdownComponent__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            headerBgColor: headerBgColor,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_LoginUserIcon__WEBPACK_IMPORTED_MODULE_12__/* .LoginUserIcon */ .i, {
                                    width: "23",
                                    height: "23",
                                    color: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_28__/* .getContrastingColor */ .Q)(headerBgColor)
                                }),
                                (user === null || user === void 0 ? void 0 : user.isLogin) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    alt: "dropdown button",
                                    src: "/assets/images/down-arrow-thin.svg",
                                    className: "ml2 arrow-icon ".concat((0,_utils_invertAngleRightIconColor__WEBPACK_IMPORTED_MODULE_9__/* .invertAngleRightIconColor */ .p)(headerBgColor))
                                }) : ""
                            ]
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                ]
            });
        } else return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CommonHeaderIcons__WEBPACK_IMPORTED_MODULE_10__/* .CommonHeaderIconsMobile */ .r, {
            color: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_28__/* .getContrastingColor */ .Q)(headerBgColor),
            headerName: "header14",
            isWhatsappIconVisible: props === null || props === void 0 ? void 0 : (ref = props.config) === null || ref === void 0 ? void 0 : (ref1 = ref.hidden_components) === null || ref1 === void 0 ? void 0 : ref1.whatsapp_view
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        ref: headerRef,
        className: "header14 collection-header",
        style: {
            background: headerBgColor,
            color: (0,_utils_getContrastingColor__WEBPACK_IMPORTED_MODULE_28__/* .getContrastingColor */ .Q)(headerBgColor)
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "header14__top-component ".concat(getHeaderStyle()),
                children: [
                    leftSection(),
                    middleSection(),
                    rightSection()
                ]
            }),
            isDesktop ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "header14__bottom-component",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "visible-desktop-flex",
                    children: (navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                        className: "header14__bottom-component--menu",
                        children: navItemsState === null || navItemsState === void 0 ? void 0 : navItemsState.map(function(nav) {
                            return renderNavType(nav, false);
                        })
                    })
                })
            }) : null,
            open.openDropdown && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionHeaderDropdown__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                renderNavType: renderNavType,
                navItemsState: navItemsState,
                openCollections: openCollections,
                isLoginVisible: props === null || props === void 0 ? void 0 : (ref2 = props.config) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.hidden_components) === null || ref3 === void 0 ? void 0 : ref3.login_view,
                goBack: function() {
                    return setOpenCollections(false);
                },
                collectionListType: (props === null || props === void 0 ? void 0 : (ref4 = props.config) === null || ref4 === void 0 ? void 0 : ref4.name) || null,
                headerName: "header14"
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Header14);


/***/ }),

/***/ 527941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* reexport */ NextImage; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(667294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(425675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/NextImage.tsx





function NextImage(props) {
    if (props.useDefaultHTMLTag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({}, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        unoptimized: true
    }));
}

;// CONCATENATED MODULE: ./src/components/DesignSystem/NextImage/index.ts



/***/ }),

/***/ 493326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(506337);

var checkIfWebview = function() {
    return !_checkRenderEnv__WEBPACK_IMPORTED_MODULE_0__/* .IS_SERVER */ .W6 && !!window.ReactNativeWebView;
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfWebview);


/***/ }),

/***/ 636874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ invertAngleRightIconColor; }
/* harmony export */ });
/* harmony import */ var _getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(956494);

/**
 * invert classes are applied on angle icon based on the headerBgColor
 * @param {*} headerBgColor
 * @return {String} a class based on headerBgColor
 */ function invertAngleRightIconColor(headerBgColor) {
    return (0,_getCustomHeaderTextColor__WEBPACK_IMPORTED_MODULE_0__/* .getCustomHeaderTextColor */ .s)(headerBgColor) === "#ffffff" ? "filter-invert-1" : "filter-invert-0";
}


/***/ })

}]);